import { API_BASE_URL } from '../config/api';
import { ApiError } from './apiClient';

function buildUrl(path) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_BASE_URL}${normalizedPath}`;
}

async function parseResponse(response) {
  const payload = await response.json().catch(() => ({
    success: false,
    data: null,
    error: 'Invalid JSON response'
  }));

  if (!response.ok || payload.success === false) {
    throw new ApiError(payload.error || `Request failed with status ${response.status}`, response.status, payload);
  }

  return payload.data;
}

export async function uploadUserAvatar(userId, file) {
  const form = new FormData();
  form.append('avatar', file);
  const response = await fetch(buildUrl(`/api/users/${encodeURIComponent(userId)}/avatar`), {
    method: 'POST',
    credentials: 'include',
    body: form
  });
  return parseResponse(response);
}

export async function removeUserAvatar(userId) {
  const response = await fetch(buildUrl(`/api/users/${encodeURIComponent(userId)}/avatar`), {
    method: 'DELETE',
    credentials: 'include'
  });
  return parseResponse(response);
}
